/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { EntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/EntitlementsQueryResource.tsx';
import { CustomerDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/CustomerDetailsPageQueryResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCustomerDetailsRoute } from '@jira/router-routes__servicedesk-customers-routes/src/servicedeskCustomerDetailsRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ServicedeskCustomerDetails, LazyServicedeskCustomerDetails } from './ui/index.tsx';

export const servicedeskCustomerDetailsRouteEntry: Route = createEntry(
	servicedeskCustomerDetailsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskCustomerDetails,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCustomerDetails],
		perfMetricKey: 'jsm-customer-details-component-load',

		meta: {
			reporting: {
				id: APP_NAMES.CUSTOMER_DETAILS,
				packageName: toPackageName(APP_NAMES.CUSTOMER_DETAILS),
				teamName: 'boysenberry',
			},
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			EntitlementsQueryResource,
			CustomerDetailsPageQueryResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
